import React, { memo, useEffect, useState } from 'react'
import { Table } from 'antd'
import querystring from 'querystring'
import classnames from 'classnames'

import { threeMonth } from '@/constants'
import styles from './index.module.scss'
import { useTranslation } from '@/services/i18n'
import TxRecordApi from '@/services/apis/history/TxRecords'
import { TxConditionModel, TxRecordsModel } from '@/services/apis/history/model'
import { PageModel } from '@/services/apis/BaseModel'
import { formatTime } from '@/utils/format'
import { resetToEndTime, resetToStartTime } from '@/utils/number'
import { TxStatusEnum } from '@/constants/enum'
import MyTable from '@/components/Table'
import ApprovalFlow from '../../../../components/ApprovalFlow'
import MpcExpandRow from '../../components/MpcExpandRow'
import ShadowView from '@/components/ShadowView'
import Shape from '@/assets/images/shape.png'
import Header from '../../components/Header'

const { Column } = Table

const MpcSign = memo(props => {
  const { t } = useTranslation()

  const [queryParam, setQueryParam] = useState<any>({
    startTime: resetToStartTime(new Date() as any) - threeMonth,
    endTime: resetToEndTime(new Date() as any),
    transactionStatus: '',
    accountKey: querystring.parse(window.location.search)?.account ?? '',
    createdByKey: '',
    txKey: '',
  })
  const [conditon, setConditon] = useState<TxConditionModel>({
    accountList: [],
    coinKey: [],
    networkList: [],
    statusList: [],
    userList: [],
  })
  const [tableLoading, setTableLoading] = useState(false)
  const [listPage, setListPage] = useState<PageModel<TxRecordsModel>>(
    {} as PageModel<TxRecordsModel>
  )

  const statusList = [...[{ key: '', desc: t('record.allStatus') }], ...conditon.statusList]
  const accountList = [...[{ key: '', desc: t('record.allAccout') }], ...conditon.accountList]
  const userList = [...[{ key: '', desc: t('record.allUser') }], ...conditon.userList]

  // 动态获取class类
  function txStatusColorClass(value: TxStatusEnum) {
    const colorMap = {
      [TxStatusEnum.CANCEL]: styles.normal,
      [TxStatusEnum.NEW]: styles.waiting,
      [TxStatusEnum.BORADCAST]: styles.waiting,
      [TxStatusEnum.CONFIRMING]: styles.waiting,
      [TxStatusEnum.FAILED]: styles.danger,
      [TxStatusEnum.REFUSE]: styles.danger,
      [TxStatusEnum.SUCCESS]: styles.success,
      [TxStatusEnum.SIGNIMG]: styles.waiting,
    }
    return colorMap[value]
  }
  const renderState = (_: any, record: TxRecordsModel) => {
    return (
      <div className={styles.stateContainer}>
        <div
          className={classnames(styles.status_dot, txStatusColorClass(record.transactionStatus))}
        ></div>
        <div>{record.transactionStatusDesc}</div>
      </div>
    )
  }
  const renderAppFlow = (_: any, record: TxRecordsModel) => {
    return (
      <div>
        {record.auditRecordDto && (
          <ApprovalFlow
            flow={record.auditRecordDto}
            isCancel={record.transactionStatus === 'CANCELLED'}
          />
        )}
      </div>
    )
  }
  const renderExpand = (record: TxRecordsModel) => {
    return <MpcExpandRow records={record} />
  }

  async function getConditionData() {
    const res = await TxRecordApi.getCondition()
    if (res.success) {
      setConditon(res.data)
    }
  }
  async function getRecordsList(page = 1) {
    setTableLoading(true)
    const res = await TxRecordApi.searchRawTxRecords({ pageNumber: page, queryParam: queryParam })
    setTableLoading(false)
    if (res.success) {
      setListPage(res.data)
    }
  }

  function changePage(page: number) {
    getRecordsList(page)
  }

  useEffect(() => {
    getRecordsList()
  }, [queryParam])

  useEffect(() => {
    getConditionData()

    getRecordsList()
  }, [])
  const [accountName, setAccountName] = useState(
    querystring.parse(window.location.search)?.accountName
  )
  function getAccountName(accountKey: string) {
    const account = accountList.filter(item => item.key === accountKey)

    if (account.length > 0) {
      setAccountName(accountKey)
    } else {
      setConditon({
        ...conditon,
        accountList: [
          ...conditon.accountList,
          {
            desc: querystring.parse(window.location.search)?.accountName as string,
            key: accountKey,
            addition: '',
          },
        ],
      })
      setAccountName(accountKey)
    }
  }
  useEffect(() => {
    getAccountName(queryParam.accountKey)
  }, [conditon.userList])

  return (
    <div className={styles.container}>
      <Header
        type="Mpc"
        queryParam={queryParam}
        setQueryParam={setQueryParam}
        tableLoading={tableLoading}
        accountName={accountName as any}
        setAccountName={setAccountName}
        condition={{
          statusList,
          accountList,
          userList,
        }}
      />
      {listPage?.totalElements > 50 && <ShadowView style={{ bottom: 60 }} />}
      <MyTable
        dataSource={listPage?.content}
        loading={tableLoading}
        pagination={{
          pageSize: 50,
          total: listPage?.totalElements,
          showSizeChanger: false,
          onChange: changePage,
          hideOnSinglePage: true,
        }}
        bottomY={90}
        rowKey={record => record.txKey}
        expandable={{
          expandedRowRender: renderExpand,
          expandIcon: ({ expanded, onExpand, record }) =>
            expanded ? (
              <div onClick={e => onExpand(record, e)} className={styles.expand}>
                <div style={{ marginRight: '5px' }}>{t('record.detail')}</div>
                <div>
                  <img
                    src={Shape}
                    alt=""
                    style={{ width: '10px', height: 'auto', transform: 'rotate(180deg)' }}
                  />
                </div>
              </div>
            ) : (
              <div onClick={e => onExpand(record, e)} className={styles.expand}>
                <div style={{ marginRight: '5px' }}>{t('record.detail')}</div>
                <div>
                  <img src={Shape} alt="" style={{ width: '10px', height: 'auto' }} />
                </div>
              </div>
            ),
          expandIconColumnIndex: 8,
          columnWidth: 200,
        }}
      >
        <Column title={t('record.time')} dataIndex="createTime" render={formatTime} />
        <Column title={t('record.platformId')} dataIndex="txKey" />
        <Column title={t('record.initialAccount')} dataIndex="sourceAccountName" width={80} />
        <Column title={t('record.signAlg')} dataIndex="signAlg" />
        <Column title={t('record.state')} render={renderState} />
        <Column title={t('record.createUser')} dataIndex="createdByUserName" />
        <Column title={t('record.subState')} dataIndex="transactionSubStatusDesc" />
        <Column title={t('common.approval')} render={renderAppFlow} />
      </MyTable>
    </div>
  )
})

export default MpcSign
